(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/View', 'app/branding-config/image/ImageReferenceDataBehavior',
            'templates', 'app/behaviors/PreviewBehavior'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    var templates = {
      asideTemplate: require('./asideTemplate.hbs')
    };
    module.exports = factory(require('backbone-torso/modules/View'), require('./../branding-config/image/ImageReferenceDataBehavior'),
                             templates, require('./../behaviors/PreviewBehavior'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoView, ImageReferenceDataBehavior,
                  templates, PreviewBehavior) {
  'use strict';

  var IMAGE_REFERENCE_NAME = 'logo-aside';

  /**
   * View to display the appointment list aside
   *
   * @class AsideView
   * @param options {Object} used to pass in the i18n key to display for the aside.
   *   @param options.asideHeaderMessageKey {String} the header message key that will be used by this aside.
   *   @param [options.asideContentView] {TorsoView} A view that will render the aside content.
   *   @param [options.asideText] {String} the text to use for the aside.  If truthy, then asideContentMessageKey is ignored.
   *   @param [options.asideContentMessageKey] {String} the content message key that will be used by this aside.
   *   @param [options.showLogo=false] {Boolean} whether to show the logo on the aside.
   */
  return new (TorsoView.extend({
    tagName: 'aside',
    className: 'brec-aside',
    template: templates.asideTemplate,

    events: {
      'click [data-aside-toggle]': '_toggleAside'
    },

    behaviors: {
      previewBehavior: PreviewBehavior,
      asideLogoImageReferences: {
        behavior: ImageReferenceDataBehavior,
        id: IMAGE_REFERENCE_NAME
      }
    },

    injectionSites: {
      'aside-content': '_asideContentView'
    },

    prepareFields: {
      hasAsideContentView: function() {
        return !!this._asideContentView;
      }
    },

    /**
     * @method initialize
     * @override
     */
    initialize: function() {
      this.set('showAside', false);
      this.listenTo(this.viewState, 'change', this.render);
    },

    /**
     * Method to update the content of the aside view. The view will automatically re-render on update.
     *
     * @method updateAsideContent
     * @param options {Object} used to pass in the i18n key to display for the aside.
     *   @param options.asideHeaderMessageKey {String} the header message key that will be used by this aside.
     *   @param [options.asideContentView] {TorsoView} A view that will render the aside content.
     *   @param [options.asideText] {String} the text to use for the aside.  If truthy, then asideContentMessageKey is ignored.
     *   @param [options.asideContentMessageKey] {String} the content message key that will be used by this aside.
     *   @param [options.showLogo=false] {Boolean} whether to show the logo on the aside.
     */
    updateAsideContent: function(options) {
      this.set({
        asideText: options.asideText,
        asideContentMessageKey: options.asideContentMessageKey,
        asideHeaderMessageKey: options.asideHeaderMessageKey,
        showLogo: options.showLogo
      });
      this._asideContentView = options.asideContentView;
    },

    /**
     * @method prepare
     * @override
     */
    prepare: function() {
      var templateContext = TorsoView.prototype.prepare.apply(this);
      var imageReferenceDataBehavior = this.getBehavior('asideLogoImageReferences');
      templateContext[IMAGE_REFERENCE_NAME] = {
        isNone: imageReferenceDataBehavior.isEmptyImageReference(IMAGE_REFERENCE_NAME)
      };
      return templateContext;
    },

    /**
     * Show/Hide aside on tablet view
     * @method _toggleAside
     * @private
     */
    _toggleAside: function(event) {
      event.preventDefault();
      var asideShown = this.get('showAside');
      if (asideShown) {
        this._setAttributes({
          'class': this.className
        });
      } else {
        this._setAttributes({
          'class': this.className + ' brec-aside--show'
        });
      }
      this.set('showAside', !asideShown);
    }
  }))();
}));
